import * as React from 'react';

/**
 * Хук, возвращающий максимальную высоту модалки до нижней границы элемента, переданного через пропсы в виде рефа
 * @param anchorRef
 */
export const useMaxModalHeight = <T extends HTMLElement>(anchorRef: React.MutableRefObject<T | null>) => {
  const [maxHeight, setMaxHeight] = React.useState(0);

  const { top = 0, height = 0 } = anchorRef.current?.getBoundingClientRect() || {};

  React.useLayoutEffect(() => {
    if (anchorRef.current) {
      setMaxHeight(window.innerHeight - top - height + 1);
    }
  }, [top, height]);

  return maxHeight;
};
